// extracted by mini-css-extract-plugin
export default {"entityPageInformation":"EntityPageInformation_entityPageInformation__B6LV-","entityPageInformationTitle":"EntityPageInformation_entityPageInformationTitle__ccgLK"};